/* Idea Mala Club — hero 3D v3
   Camiseta con el estampado horneado en su textura, sobre un pedestal.
   Sin simulación de tela: reposo limpio, luz de plató, giro lento con arrastre. */
(function () {
  var stage = document.getElementById('im3Stage');
  var P = window.IM3_PRODUCTS || [];
  if (!stage || !P.length) return;

  var section = stage.closest('.im3') || document.body;
  var nameEl = document.getElementById('im3Name');
  var idxEl = document.getElementById('im3Idx');
  var buyEl = document.getElementById('im3Buy');
  var fallback = document.getElementById('im3Fallback');
  var dotsWrap = document.getElementById('im3Dots');
  var dots = dotsWrap ? [].slice.call(dotsWrap.children) : [];
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var cur = 0;
  function luma(hex) {
    var c = hex.replace('#', '');
    if (c.length === 3) c = c.replace(/(.)/g, '$1$1');
    var n = parseInt(c, 16);
    return (0.299 * (n >> 16 & 255) + 0.587 * (n >> 8 & 255) + 0.114 * (n & 255)) / 255;
  }
  function paintUI(i) {
    var p = P[i];
    if (nameEl) nameEl.textContent = p.title;
    if (idxEl) idxEl.textContent = (i + 1 < 10 ? '0' : '') + (i + 1);
    if (buyEl) { buyEl.href = p.url; buyEl.innerHTML = 'Comprar ' + p.price + ' <span class="im-arr">&rarr;</span>'; }
    dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
    var bg = p.bg || '#EFE9DF';
    section.style.setProperty('--im3-bg', bg);
    section.style.setProperty('--im3-fg', luma(bg) > 0.55 ? '#171716' : '#EFE9DF');
  }

  /* ---------- fallback sin WebGL ---------- */
  var gl = null;
  try { var c = document.createElement('canvas'); gl = c.getContext('webgl2') || c.getContext('webgl'); } catch (e) {}
  if (!gl || !window.THREE || !THREE.GLTFLoader) {
    paintUI(0);
    if (fallback) {
      fallback.style.display = 'block';
      if (!reduce) setInterval(function () { cur = (cur + 1) % P.length; fallback.src = P[cur].img; paintUI(cur); }, 3500);
    }
    return;
  }
  if (fallback) fallback.style.display = 'none';

  /* ---------- escena ---------- */
  var renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true, powerPreference: 'high-performance' });
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 0.96;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.setClearColor(0x000000, 0);
  stage.appendChild(renderer.domElement);

  var scene = new THREE.Scene();
  var camera = new THREE.PerspectiveCamera(26, 1, 0.1, 20);

  /* luz de plató: entorno HDR sintético (softboxes) */
  function makeStudioEnv() {
    var w = 512, h = 256, cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    var g = cv.getContext('2d');
    var grad = g.createLinearGradient(0, 0, 0, h);
    grad.addColorStop(0, '#ffffff'); grad.addColorStop(0.42, '#e9e6e0'); grad.addColorStop(0.62, '#b9b5ad'); grad.addColorStop(1, '#4a4741');
    g.fillStyle = grad; g.fillRect(0, 0, w, h);
    function box(x, y, bw, bh, a) {
      var r = g.createRadialGradient(x, y, 0, x, y, Math.max(bw, bh));
      r.addColorStop(0, 'rgba(255,255,255,' + a + ')'); r.addColorStop(1, 'rgba(255,255,255,0)');
      g.fillStyle = r; g.fillRect(x - bw, y - bh, bw * 2, bh * 2);
    }
    box(w * 0.30, h * 0.22, 90, 60, 0.95);
    box(w * 0.75, h * 0.30, 70, 50, 0.6);
    box(w * 0.52, h * 0.06, 160, 30, 0.9);
    var t = new THREE.CanvasTexture(cv);
    t.mapping = THREE.EquirectangularReflectionMapping;
    t.encoding = THREE.sRGBEncoding;
    var pm = new THREE.PMREMGenerator(renderer);
    var env = pm.fromEquirectangular(t).texture;
    t.dispose(); pm.dispose();
    return env;
  }
  scene.environment = makeStudioEnv();

  var key = new THREE.DirectionalLight(0xffffff, 1.35);
  key.position.set(0.9, 2.4, 1.6);
  key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  key.shadow.camera.near = 0.5; key.shadow.camera.far = 6;
  key.shadow.camera.left = -0.9; key.shadow.camera.right = 0.9;
  key.shadow.camera.top = 0.9; key.shadow.camera.bottom = -0.9;
  key.shadow.radius = 6; key.shadow.bias = -0.0006; key.shadow.normalBias = 0.01;
  scene.add(key);
  var fill = new THREE.DirectionalLight(0xffffff, 0.35); fill.position.set(-1.6, 0.6, 1.2); scene.add(fill);
  var rim = new THREE.DirectionalLight(0xffffff, 0.45); rim.position.set(0.2, 1.2, -2.2); scene.add(rim);
  scene.add(new THREE.AmbientLight(0xffffff, 0.12));

  /* pedestal de piedra clara */
  var PED_R = 0.34, PED_H = 0.085, PED_TOP = -0.40;
  var stone = new THREE.MeshStandardMaterial({ color: 0xcbc3b3, roughness: 0.9, metalness: 0.0, envMapIntensity: 0.6 });
  var stoneTop = new THREE.MeshStandardMaterial({ color: 0xd9d2c3, roughness: 0.86, metalness: 0.0, envMapIntensity: 0.7 });
  var ped = new THREE.Mesh(new THREE.CylinderGeometry(PED_R, PED_R * 1.02, PED_H, 128, 1, false), [stone, stoneTop, stone]);
  ped.position.y = PED_TOP - PED_H / 2;
  ped.receiveShadow = true; ped.castShadow = false;
  scene.add(ped);

  /* camiseta */
  var group = new THREE.Group(); scene.add(group);
  var shirt = null, shirtMat = null;
  var cotton = { color: 0xffffff, roughness: 0.95, metalness: 0, sheen: 0.22, sheenRoughness: 0.9, sheenColor: new THREE.Color(0xffffff), envMapIntensity: 0.75 };

  var loader = new THREE.TextureLoader();
  var maxAniso = renderer.capabilities.getMaxAnisotropy();
  var texes = P.map(function (p) {
    if (!p.tex) return null;
    var t = loader.load(p.tex);
    t.encoding = THREE.sRGBEncoding; t.flipY = false; t.anisotropy = maxAniso;
    t.minFilter = THREE.LinearMipmapLinearFilter; t.generateMipmaps = true;
    return t;
  });

  var BASE_H = 0.62;
  new THREE.GLTFLoader().load(window.IM3_MODEL, function (gltf) {
    var root = gltf.scene;
    var box = new THREE.Box3().setFromObject(root);
    var size = new THREE.Vector3(); box.getSize(size);
    var center = new THREE.Vector3(); box.getCenter(center);
    var s = BASE_H / size.y;
    root.scale.setScalar(s);
    root.position.set(-center.x * s, -center.y * s, -center.z * s);
    root.traverse(function (o) {
      if (!o.isMesh) return;
      shirtMat = new THREE.MeshPhysicalMaterial(cotton);
      shirtMat.map = texes[cur] || null;
      shirtMat.sheenColorMap = texes[cur] || null; /* el brillo se apaga sobre la tinta */
      /* sin mapa de normales (grano): tela lisa. Conservamos las normales suaves del modelo. */
      o.material = shirtMat;
      o.castShadow = true; o.receiveShadow = true;
      o.geometry.computeVertexNormals();
    });
    shirt = root;
    group.add(root);
    frame();
    fadeIn();
  }, undefined, function () {
    if (fallback) fallback.style.display = 'block';
  });

  function setTexture(i) {
    if (shirtMat && texes[i]) { shirtMat.map = texes[i]; shirtMat.sheenColorMap = texes[i]; shirtMat.needsUpdate = true; }
  }
  function goTo(i) { cur = (i + P.length) % P.length; paintUI(cur); setTexture(cur); }
  dots.forEach(function (d, k) { d.style.pointerEvents = 'auto'; d.style.cursor = 'pointer'; d.addEventListener('click', function () { goTo(k); }); });

  /* encuadre: camiseta + pedestal siempre dentro, con aire */
  var NEED_H = BASE_H + 0.09 + PED_H + 0.22;
  var NEED_W = 0.95;
  function frame() {
    var w = stage.clientWidth || 600, h = stage.clientHeight || 500;
    var aspect = w / Math.max(h, 1);
    camera.aspect = aspect; camera.updateProjectionMatrix();
    var vfov = camera.fov * Math.PI / 180;
    var dH = (NEED_H / 2) / Math.tan(vfov / 2);
    var dW = (NEED_W / 2) / (Math.tan(vfov / 2) * aspect);
    var d = Math.max(dH, dW);
    camera.position.set(0, 0.34, d * 0.98);
    camera.lookAt(0, -0.09, 0);
    renderer.setSize(w, h, false);
  }
  window.addEventListener('resize', frame);

  /* fade-in del canvas */
  renderer.domElement.style.opacity = '0';
  renderer.domElement.style.transition = 'opacity .7s ease';
  function fadeIn() { requestAnimationFrame(function () { renderer.domElement.style.opacity = '1'; }); }

  /* giro: lento y constante; arrastrar lo lanza y vuelve suave */
  var BASE_SPEED = reduce ? 0 : 0.21;   /* rad/s ≈ 12°/s: una vuelta en 30 s */
  var speed = BASE_SPEED, rot = -0.35, dragging = false, lastX = 0, lastT = 0, vel = 0;
  var el = renderer.domElement;
  el.addEventListener('pointerdown', function (e) { dragging = true; lastX = e.clientX; lastT = performance.now(); vel = 0; el.setPointerCapture && el.setPointerCapture(e.pointerId); });
  window.addEventListener('pointermove', function (e) {
    if (!dragging) return;
    var now = performance.now(), dx = e.clientX - lastX, dt = Math.max(1, now - lastT) / 1000;
    var dr = dx * 0.012; rot += dr; vel = dr / dt; lastX = e.clientX; lastT = now;
  });
  window.addEventListener('pointerup', function () { if (!dragging) return; dragging = false; speed = Math.max(-6, Math.min(6, vel)); });

  var lastSwitchTurn = 0, t0 = performance.now(), last = t0;
  function tick(now) {
    var dt = Math.min(0.05, (now - last) / 1000); last = now;
    if (!dragging) {
      rot += speed * dt;
      speed += (BASE_SPEED - speed) * Math.min(1, dt * 1.6);
    }
    group.rotation.y = rot;
    /* flota muy suave */
    group.position.y = 0.01 * Math.sin((now - t0) / 1000 * 0.9);
    /* cambio de diseño cada vuelta, cuando la espalda mira al espectador */
    var turns = Math.floor((rot - Math.PI) / (Math.PI * 2));
    if (!reduce && !dragging && turns > lastSwitchTurn && speed > 0) { lastSwitchTurn = turns; goTo(cur + 1); }
    renderer.render(scene, camera);
    requestAnimationFrame(tick);
  }
  paintUI(0);
  frame();
  requestAnimationFrame(tick);

  window.__im3 = { get rot() { return rot; }, set rot(v) { rot = v; }, set speed(v) { speed = v; }, goTo: goTo, renderer: renderer };
})();
